import { ListResults } from './../data/datalist.model';
import { ProductPaginationV3Model } from './../data/datalist.model';

export interface IStockProductsFilterWms {
  warehouse_id__eq?: number | string;
  last_evaluated_key_id?: string | null | undefined;
  state__eq?: string;
  variant_id__eq?: number | string;
  location_id__eq?: number | string;
  location_name__like?: string;
  container_lpn_code__like?: string;
  variant_name__like?: string;
  variant_external_id__like?: string;
  variant_barcode__eq?: string;
  page?: number;
  page_size?: number;
  search?: string;
}

export interface IStockProduct {
  related_model: IRelatedModel;
  due_date_unix_epoch: number | null;
  created: string;
  customer_id: null;
  warnings: string[];
  due_date: string;
  volume_used: number;
  state: string;
  modified_unix_epoch: number;
  weight_used: number;
  warehouse_id: string;
  created_unix_epoch: number;
  external_id: null;
  location_id: string;
  created_by_username: string;
  sk: string;
  amount: number;
  id: string;
  pk: string;
  variant_id: string;
  modified_by_username: string;
  modified: Date;
  batch: string;
  container_id: number | null;
  container: IContainer | null;
  location: ILocation;
  variant: IVariant;
  rejected_amount?: number;
  inventory_id?: number;
}

export interface IContainer {
  lpn_code: string;
  status: string;
  type: string;
  location_id: string;
}

export interface ILocation {
  id: string;
  external_id: string;
  name: string;
}

export interface IRelatedModel {
  model?: string;
  pk?: string;
}

export interface IVariant {
  id: number;
  barcode: string;
  barcode_history: string[];
  display_name: string;
  external_id: string;
  image_files: string[];
  measure_unit: string;
  name: string;
  presentation: string;
  properties: IProperties;
  reference_id: string;
  tagging: string;
}

export interface IProperties {
  volume: string;
  height_measurement_unit: string;
  large: string;
  volume_measurement_unit: string;
  width: string;
  weight: string;
  weight_measurement_unit: string;
  None?: string;
  width_measurement_unit: string;
  large_measurement_unit: string;
  height: string;
  brand_names?: string;
  is_on_demand?: string;
  supplier_name?: string;
}

export type IStockProductResponse = ListResults<IStockProduct>;

/**
 * Raw response structure returned by the Stock Product V3 API endpoint.
 * Includes pagination metadata for server-side paging.
 */
export interface IStockProductV3Response {
  count: number;
  warnings: string[];
  pagination: ProductPaginationV3Model;
  results: IStockProduct[];
}
